/**
 * What dated reference data a backtest used (Phase 5): lot-size changes per index,
 * and warnings for rate rows that rest on unverified / secondary sources.
 */
import { Alert, Typography } from "@mui/material";
import type { BacktestReferenceData } from "@/types";

export function lotChangesText(ref: BacktestReferenceData): string {
  return Object.entries(ref.lot_sizes ?? {})
    .map(([ix, rows]) => `${ix} ${rows.map((r) => `${r.lot_size} from ${r.from_trade_date}`).join(", ")}`)
    .join(" · ");
}

export default function ReferenceDataNote({ reference }: { reference?: BacktestReferenceData | null }) {
  if (!reference) return null;
  if (reference.mode === "CURRENT") {
    return (
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }} data-testid="reference-data-note">
        Reference data: today&apos;s lot size, expiry rules and charge rates for every date.
      </Typography>
    );
  }
  return (
    <Alert severity={reference.warnings?.length ? "warning" : "info"} sx={{ mt: 1 }} data-testid="reference-data-note">
      <Typography variant="body2">
        Reference data as of each trade date (researched {reference.researched_on ?? "—"}). Lot sizes: {lotChangesText(reference) || "—"}.
      </Typography>
      {(reference.warnings ?? []).map((w) => (
        <Typography key={w} variant="caption" display="block">{w}</Typography>
      ))}
    </Alert>
  );
}
